/* unplugin-vue-components disabled */import script from "./Reg.vue?vue&type=script&setup=true&lang=js"
export * from "./Reg.vue?vue&type=script&setup=true&lang=js"

import "./Reg.vue?vue&type=style&index=0&id=4663262c&scoped=true&lang=css"

import exportComponent from "D:\\noui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4663262c"]])

export default __exports__